module.exports = __webpack_public_path__ + "static/media/logo-menu.da3ec00a.svg";